import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLoading } from '../../../components/LoadingContext/LoadingContext';
import { questionnaireService } from '../services/questionnaireService';

interface QuestionResponse {
  questionId: string;
  questionType: string;
  response: any;
}

interface SubmitParams {
  respostas: QuestionResponse[];
  // dadosServidor: any;
  eventUId: string;
}

interface UseResponderPesquisaReturn {
  submitRespostas: (params: SubmitParams) => void;
  isSubmitting: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
}

export const useResponderPesquisa = (): UseResponderPesquisaReturn => {
  const { startLoading, stopLoading } = useLoading();
  const history = useHistory();
  const hasSubmittedRef = useRef(false);

  const mutation = useMutation<any, Error, SubmitParams>({
    mutationFn: ({ respostas, eventUId }: SubmitParams) =>
      questionnaireService.postPesquisaResponder(
        respostas,
        // dadosServidor,
        eventUId
      ),
    onSuccess: () => {
      hasSubmittedRef.current = true;
      toast.success('Respostas enviadas com sucesso!');
      setTimeout(() => {
        history.push('/home-user');
      }, 1);
    },
    onError: (error) => {
      toast.error('Erro ao enviar as respostas. Tente novamente.');
      console.error('Erro no envio:', error);
    },
    retry: false,
  });

  useEffect(() => {
    if (mutation.isPending) {
      startLoading();
    } else {
      stopLoading();
    }
  }, [mutation.isPending, startLoading, stopLoading]);

  return {
    submitRespostas: (params: SubmitParams) => {
      if (mutation.isPending || hasSubmittedRef.current) {
        console.warn('Submissão já em andamento ou já foi enviada');
        return;
      }
      mutation.mutate(params);
    },
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.isError ? mutation.error : null,
  };
};
